import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/appointment';

class AppointmentService {
  getClientAppointments = async ({ id }) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/client/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data, message } = response.data;
      return { data, message };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching client appointments.');
    }
  };

  createAppointmentForClient = async (id, body) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/client/${id}`, body);
      if (response.status !== 201) {
        throw new Error();
      }

      const { data } = response.data;

      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating appointment for client.');
    }
  };

  createAppointmentForLeadClient = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/client/lead`, body);
      if (response.status !== 201) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating appointment for lead client.');
    }
  };

  getVendorOccupiedPeriod = async date => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/occupied?date=${date}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching occupied appointments.');
    }
  };

  getAllVendorAppointments = async date => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/vendor/all`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching appointments.');
    }
  };

  editAppointment = async (id, body) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/edit/${id}`, body);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while editing appointment.');
    }
  };

  createUnavailableAppointment = async body => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}//vendor/unavailable`, body);
      if (response.status !== 201) {
        throw new Error();
      }

      const { data } = response.data;

      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating unavailable appointment .');
    }
  };

  acceptClientAppointment = async (appointmentId, notificationId) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/accept/${appointmentId}`, { notificationId });
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;

      return { data, appointmentId, notificationId };
    } catch (err) {
      throw handleError(err, 'Error occurred while accepting appointment.');
    }
  };

  rejectClientAppointment = async (appointmentId, notificationId) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/reject/${appointmentId}`, { notificationId });
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;

      return { data, appointmentId, notificationId };
    } catch (err) {
      throw handleError(err, 'Error occurred while rejecting appointment.');
    }
  };

  deleteAppointment = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/vendor/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;
      return { data, id };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting appointment.');
    }
  };
}
const appointmentService = new AppointmentService();

export default appointmentService;
